import { EMedicalCategoryCategory } from '@/entities/medical-category';
import useAuthModal from '@/hooks/useAuthModal';
import useNavigate from '@/hooks/useNavigate';
import { DiagnosisCategoryType } from '@/models/diagnosis';
import { getAuthToken } from '@/recoil/atoms/common/auth';
import { useRouter } from 'next/router';

const WEB_DIAGNOSIS_DISABLED_CATEGORIES = [
  {
    id: '12',
    category: EMedicalCategoryCategory.TREATMENT,
  },
];

export interface TelemedicineRequestProps {
  type: DiagnosisCategoryType;
  categoryId: string;
  redirectUrl: string;
}

const useTelemedicineRequest = () => {
  const { setShowAuthModal } = useAuthModal(true, false);
  const navigate = useNavigate();
  const router = useRouter();
  const token = getAuthToken();

  const getIsEnabledWebTelemedicineCategory = (categoryId: string) => {
    return !WEB_DIAGNOSIS_DISABLED_CATEGORIES.some((category) => category.id === categoryId);
  };

  const onClickTelemedicineRequest = ({ categoryId, type, redirectUrl }: TelemedicineRequestProps) => {
    if (!token) {
      setShowAuthModal(true, redirectUrl);
      return;
    }

    const isEnabledWebTelemedicineCategory = getIsEnabledWebTelemedicineCategory(categoryId);
    if (isEnabledWebTelemedicineCategory) {
      navigate.navigateToTelemedicineRequestScreen({
        categoryId,
        type,
      });
      return;
    }

    router.push(redirectUrl);
  };

  return {
    onClickTelemedicineRequest,
  };
};

export default useTelemedicineRequest;
